
export interface IDonorDiagnosticRequest {
    id: number,
    centerId: number,
    email: string,
    firstName: string,
    middleInitial: string,
    lastName: string,
    preferredName: string,
    donationType: number,
    entryDomain: string,
    editKey: string,
    currentRegistrationStep: number,
    stopCommunication: boolean,
    isAcceptable: boolean,
    connectToDonorGroup: number,
    closeLoopSurgeryDateTime: string,
    isCurrentlyIncarcerated: boolean,
    isResidingInUsa: boolean,
    isAbleToGetToUsa: boolean,
    isDonatingForCompensation: boolean,
    willAcceptTransfusions: boolean,
    hasHadKidneyDisease: boolean,
    hasHadHeartAttack: boolean,
    hasDiabetes: boolean,
    diabetesStatus: number,
    hasHadCancer: boolean,
    hasHadKidneyStones: boolean,
    kidneyStoneEpisodes: number,
    kidneyStoneRemissionStatus: number,
    hasBeenPregnant: boolean,
    isPregnant: boolean,
    monthsSincePregnant: number,
    isNursing: boolean,
    hadGestationalDiabetes: boolean,
    hasUsedTobacco: boolean,
    usesTobacco: boolean,
    willStopTobaccoUse: boolean,
    hasHiv: number,
    weightLbs: number,
    heightInches: number,
    birthDate: string,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    countryOfResidenceId: number | null,
    postalCode: number,
    donorSituation: number,
    ddRecipFirstName: string,
    ddRecipLastName: string,
    ddRecipDob: string,
    preWorkupLabStep: number,
    phoneNumber: string,
    phoneNumberSecondary: string,
    mobileAuthPhone: string,
    isMobileAuthPhoneConfirmed: boolean,
    expireDateTime: string,
    isConfirm: boolean,
    sendReScreen: boolean,
    intendedRecipientCenter: number
}